// Mock data for events
import { v4 as uuidv4 } from "uuid";

export const eventsData = [
  {
    id: "g1a2m3i4-n5g6-h7a8-c9k0-at1o2n3456789",
    title: "Gaming Hackathon - Industry 4.0+",
    eventType: "hackathon",
    description:
      "Create innovative gaming solutions and interactive experiences leveraging Uganda's Sovereign Cloud Platform to address real-world challenges through gamification.",
    fullDescription:
      "Join us for the Gaming Hackathon - Industry 4.0+, a 72-hour intensive innovation sprint focused on developing cutting-edge gaming solutions and interactive experiences that leverage Uganda's Sovereign Cloud Platform to create innovative products and services.\n\nThis hackathon brings together game developers, creative designers, software engineers, and innovators to showcase Uganda's capacity in the gaming industry. Participants will explore opportunities across multiple gaming sectors.\n\nChallenge Categories\n🎮 GAME DEVELOPMENT: Full game creation for mobile, web, or PC platforms\n\n🎯 GAMIFICATION: Apply game mechanics to solve real-world problems in education, healthcare, or business\n\n🎨 INTERACTIVE EXPERIENCES: Create immersive 3D environments, AR/VR experiences, or interactive simulations\n\n🌐 MULTIPLAYER & SOCIAL: Develop engaging multiplayer games and social gaming platforms\n\nThe hackathon is structured around GAMING-FOCUSED CATEGORIES that foster creativity and innovation. These are NOT fixed requirements, but GUIDING THEMES to help participants align their creativity with market opportunities.\n\nTeams are FREE to define their own gaming concepts and develop innovative solutions within these areas!",
    date: "March 10-31, 2026",
    startDate: "2026-03-10",
    endDate: "2026-03-31",
    location: "Online & Onsite (Kampala)",
    prizes: "$15,000 in cash prizes and game publishing opportunities",
    deadline: "2026-03-08",
    requirements: [
      "Game developer or creative technologist on team",
      "Team of 2-6 members",
      "Ugandan nationals or residents",
      "Commitment to full hackathon duration",
      "Must use Sovereign Cloud resources",
      "Passion for gaming and interactive media",
    ],
    tags: ["Gaming", "Game Development", "Gamification", "AR/VR", "Creative Tech"],
    image: "/Images/hackathon2.png",
    judges: [
      {
        name: "Emmanuel Kiwanuka",
        title: "Game Developer Lead",
        organization: "Outpost Studios Uganda",
      },
      {
        name: "Anita Ssembajja",
        title: "Creative Director",
        organization: "Upland Games Africa",
      },
      {
        name: "David Kayiira",
        title: "Gaming Industry Expert",
        organization: "Uganda Gaming Association",
      },
      {
        name: "Rachel Nsubuga",
        title: "AR/VR Specialist",
        organization: "Immersive Tech Solutions",
      },
      {
        name: "Samuel Muwonge",
        title: "Mobile Game Developer",
        organization: "Kampala Game Studios",
      },
      {
        name: "Prof. Grace Kamatenesi",
        title: "Digital Media Expert",
        organization: "Makerere University",
      },
      {
        name: "Alex Kiprotich",
        title: "Game Designer",
        organization: "African Game Dev Network",
      },
      {
        name: "Dr. Stella Nakawunde",
        title: "Gamification Researcher",
        organization: "Uganda Tech Institute",
      },
    ],
    overview: {
      theme: "Gaming Innovation for Uganda",
      objective:
        "Develop innovative gaming solutions and interactive experiences that address real-world challenges while showcasing Uganda's capacity in the global gaming industry.",
      format:
        "72-hour intensive hackathon with game development training, expert mentorship, sovereign cloud access, and industry showcase pitching",
      audience:
        "Game developers, game designers, software engineers, artists, creative technologists, university students, entrepreneurs",
      expectedOutcome:
        "Market-ready gaming prototypes, publishable games, gamified solutions, and potential investment or publishing partnerships",
      videoUrl: "https://www.youtube.com/watch?v=example",
      videoTitle: "Gaming Industry Opportunities",
      infrastructure: {
        title: "Cutting-Edge Gaming Development Tools",
        description: "Access Uganda's Sovereign Cloud Platform, game engines (Unity, Unreal, Godot), AR/VR development kits, multiplayer networking infrastructure, and game publishing partnerships, with mentorship from industry-leading game developers and entrepreneurs."
      }
    },

    challengeCategories: [
      {
        emoji: "🎮",
        title: "GAME DEVELOPMENT",
        subtitle: "Full game creation for mobile, web, or PC platforms",
        description:
          "Create engaging, fully functional games across any platform. Whether it's a mobile puzzle game, a web-based multiplayer experience, or a PC action adventure, we want to see your creativity come to life with polished mechanics and compelling gameplay."
      },
      {
        emoji: "🎯",
        title: "GAMIFICATION",
        subtitle: "Apply game mechanics to solve real-world problems in education, healthcare, or business",
        description:
          "Transform everyday activities into engaging experiences using game design principles. Create solutions that motivate behavior change, enhance learning outcomes, improve health outcomes, or boost business productivity through the power of gamification."
      },
      {
        emoji: "🎨",
        title: "INTERACTIVE EXPERIENCES",
        subtitle: "Create immersive 3D environments, AR/VR experiences, or interactive simulations",
        description:
          "Push the boundaries of interactivity and immersion. Build 3D worlds, augmented reality applications, virtual reality experiences, or interactive simulations that captivate users and create memorable experiences."
      },
      {
        emoji: "🌐",
        title: "MULTIPLAYER & SOCIAL",
        subtitle: "Develop engaging multiplayer games and social gaming platforms",
        description:
          "Create platforms where players connect, compete, and collaborate. Build multiplayer games with engaging social features, community management tools, or gaming platforms that foster meaningful player interactions."
      }
    ],

    workPlan: {
      "Item 1 - Call for Game Developers": {
        phase: "Call for Game Developers",
        activities: [
          "Launch open call targeting game developers, designers, and creative technologists.",
          "Publish gaming challenge statements and categories.",
          "Provide registration guidelines and allocate sovereign cloud resources.",
          "Target 150 applicants, shortlist ~80 participants.",
        ],
        timeline: "Item 1",
        responsible: "Gaming Industry Partners & Technical Committee",
      },
      "Item 2 - Training & Mentorship": {
        phase: "Game Development Training Sessions",
        activities: [
          "Conduct training on game engines (Unity, Unreal, Godot).",
          "Workshops on game design, AR/VR, and multiplayer development.",
          "Pair teams with gaming mentors and technical experts.",
          "Provide access to asset libraries and development tools.",
          "Ensure at least 85% participant engagement.",
        ],
        timeline: "Item 2",
        responsible: "Game Development Mentors & Technical Team",
      },
      "Item 3 - Game Development Sprint": {
        phase: "72-Hour Game Development Sprint",
        activities: [
          "Host intensive hybrid game jam (online + onsite at development studios).",
          "Teams develop playable game prototypes using cloud resources.",
          "Continuous mentorship, playtesting, and feedback.",
          "Preselect top 10 games for final showcase.",
        ],
        timeline: "Item 3",
        responsible: "Technical Committee & Gaming Mentors",
      },
      "Item 4 - Gaming Exhibition & Awards": {
        phase: "Game Exhibition & Awards Ceremony",
        activities: [
          "Final showcase of top games at gaming industry event.",
          "Live gameplay demos and developer pitches.",
          "Announcement of winners and publishing opportunities.",
          "Networking with publishers, investors, and industry leaders.",
          "Media coverage for visibility.",
        ],
        timeline: "Item 4",
        responsible: "Gaming Industry Partners & Organizers",
      },
    },
    resources: {
      tools: [
        "Unity Engine",
        "Unreal Engine",
        "Godot Engine",
        "Blender (3D modeling)",
        "Adobe Creative Suite",
        "Visual Studio Code",
        "GitHub",
      ],
      datasets: [
        "Game asset libraries",
        "Open-source game resources",
        "3D model collections",
        "Audio and music libraries",
      ],
      apis: [
        "Game engine APIs",
        "Cloud gaming APIs",
        "Multiplayer networking APIs",
        "AR/VR SDKs",
        "Analytics APIs",
      ],
      mentors: [
        "Emmanuel Kiwanuka (Game Developer)",
        "Anita Ssembajja (Creative Director)",
        "David Kayiira (Industry Expert)",
        "Rachel Nsubuga (AR/VR Specialist)",
      ],
    },
    milestones: [
      { title: "Application Deadline", date: "2026-03-08" },
      { title: "Team Formation Complete", date: "2026-03-09" },
      { title: "Hackathon Kickoff", date: "2026-03-10" },
      { title: "Development Sprint", date: "2026-03-10 to 2026-03-12" },
      { title: "Game Exhibition & Awards", date: "2026-03-31" },
    ],
    lessons: {
      "2026-03-10": [
        {
          id: 1,
          title: "Game Design Fundamentals",
          duration: "2 hours",
          instructor: "Emmanuel Kiwanuka",
          type: "video",
          status: "upcoming",
          description:
            "Learn core game design principles, player engagement, and mechanics that make games compelling.",
        },
        {
          id: 2,
          title: "Unity Engine Essentials",
          duration: "3 hours",
          instructor: "David Kayiira",
          type: "tutorial",
          status: "upcoming",
          description:
            "Step-by-step guide to getting started with Unity, creating scenes, sprites, and game mechanics.",
        },
      ],
      "2026-03-11": [
        {
          id: 3,
          title: "AR/VR Game Development",
          duration: "2.5 hours",
          instructor: "Rachel Nsubuga",
          type: "video",
          status: "upcoming",
          description:
            "Explore augmented and virtual reality game development with practical examples and SDKs.",
        },
        {
          id: 4,
          title: "Multiplayer Networking for Games",
          duration: "2 hours",
          instructor: "Samuel Muwonge",
          type: "tutorial",
          status: "upcoming",
          description:
            "Learn how to implement multiplayer functionality and real-time networking in your games.",
        },
      ],
    },
  },
  {
    id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    title: "Industrial 4.0 + Hackathon ",
    eventType: "hackathon",
    description:
      "Build AI and hardware solutions leveraging Uganda's Sovereign Cloud Platform to address challenges in Agriculture, Tourism, Mining, and STI sectors.",
    fullDescription:
      "Join us for the 1st Industry 4.0+ Hackathon, a 72-hour intensive innovation sprint focused on developing AI and hardware solutions that leverage Uganda's Sovereign Cloud Platform to address pressing challenges in Agriculture, Tourism, Mining, and Science & Technology Innovation (STI).\n\nThis hackathon serves as a pre-event to the official launch of the Sovereign Cloud Platform at the Deep Tech Centre of Excellence, bringing together innovators from universities, startups, and industry to demonstrate Uganda's capacity to build locally-developed solutions for national priority sectors.\nChallenge Categories\n🌾 AGRICULTURE: Smart Farming & Market Access\n\n🏞️ TOURISM: Intelligent Visitor Experiences \n\n🔒 MINING: Safety, Efficiency & Transparency\n\n 💻STI: Innovation & Research Infrastructure\n\nThe hackathon is structured around FOUR BROAD CATEGORIES that reflect Uganda's national priorities. These categories are NOT fixed problem statements, but GUIDING THEMES to help participants align their creativity with real sector needs. \n\nTeams are FREE to define their own problems and design innovative solutions within these areas!.",
    date: "September 5th, 2025",
    startDate: "2025-09-05",
    endDate: "2025-10-02",
    location: "Online",
    prizes: "$12,000 in cash and support",
    deadline: "2025-09-23",
    requirements: [
      "Technical developer/engineer on team",
      "Team of 3-6 members",
      "Ugandan nationals",
      "Commitment to all hackathon online phases",
      "Must leverage Sovereign Cloud and/or EDIC facilities",
      "Passion for AI/IoT innovation",
    ],
    tags: ["Agriculture", "Tourism", "Mining", "STI"],
    image: "/Images/hackathon2.png",
    judges: [
      {
        name: "Dr. Sarah Nabwire",
        title: "AI Research Lead",
        organization: "Makerere University",
      },
      {
        name: "James Mwangi",
        title: "Healthcare Tech Director",
        organization: "Safaricom Health",
      },
      {
        name: "Prof. David Mukasa",
        title: "Agriculture Innovation Expert",
        organization: "Uganda Agri-Tech",
      },
      {
        name: "Lisa Chen",
        title: "EdTech Entrepreneur",
        organization: "Learning Labs Africa",
      },
      {
        name: "Dr. Michael Ogwang",
        title: "AI Ethics Researcher",
        organization: "African AI Institute",
      },
      {
        name: "Grace Namugga",
        title: "HealthTech Investor",
        organization: "Impact Ventures",
      },
      {
        name: "Robert Asiimwe",
        title: "Machine Learning Engineer",
        organization: "Google Africa",
      },
      {
        name: "Dr. Fatuma Hassan",
        title: "Data Science Director",
        organization: "DataKind Uganda",
      },
    ],
    overview: {
      theme: "Sovereign Cloud",
      objective:
        "Develop AI-powered solutions that address real-world challenges in healthcare, education, and agriculture across East Africa.",
      format:
        "72-hour intensive hackathon with AI/IoT training, expert mentorship, sovereign cloud access, and national showcase pitching",
      audience:
        "University students, developers, startups, innovators, researchers, entrepreneurs across Uganda",
      expectedOutcome:
        "AI and hardware solutions addressing national challenges with direct pathway to incubation and Sovereign Cloud launch showcase",
      videoUrl: "https://www.youtube.com/watch?v=3JXj16Xvpg8",
      videoTitle: "Deep Tech Center of Excellence Launch",
      infrastructure: {
        title: "Cutting-Edge Infrastructure",
        description: "Access Uganda's Sovereign Cloud Platform, IoT development tools, AI/ML frameworks, and hardware prototyping facilities at EDIC, with mentorship from leading researchers and entrepreneurs."
      }
    },

    challengeCategories: [
      {
        emoji: "🌾",
        title: "AGRICULTURE",
        subtitle: "Smart Farming & Market Access",
        description:
          "Transform farming with AI software and IoT for crop monitoring, disease detection, and market connectivity. Create solutions that help farmers increase yields, reduce costs, and access better markets using cutting-edge technology."
      },
      {
        emoji: "🏞️",
        title: "TOURISM",
        subtitle: "Intelligent Visitor Experiences",
        description:
          "Enrich Uganda's tourism with AI-powered guides, cultural experiences, and sustainable eco-tourism platforms. Build solutions that showcase Uganda's natural beauty and cultural heritage while supporting local communities."
      },
      {
        emoji: "⛏️",
        title: "MINING",
        subtitle: "Safety, Efficiency & Transparency",
        description:
          "Enhance mining safety and efficiency with IoT systems, AI analysis, and blockchain transparency. Create solutions that improve worker safety, optimize resource extraction, and ensure responsible mining practices."
      },
      {
        emoji: "🔬",
        title: "STI",
        subtitle: "Innovation & Research Infrastructure",
        description:
          "Build the next-generation homegrown solutions powered by Uganda's Sovereign Cloud and supported by national innovation infrastructure. Design platforms that promote local content, secure data sovereignty, and showcase African-first technology."
      }
    ],

    workPlan: {
      "Item 1 - Call for Hackers": {
        phase: "Call for Hackers",
        activities: [
          "Launch open call targeting universities, startups, and industry innovators.",
          "Publish challenge statements aligned to ATMS sectors.",
          "Provide registration guidelines and allocate sovereign cloud accounts.",
          "Target 200 applicants, shortlist ~100 participants.",
        ],
        timeline: "Item 1",
        responsible: "Industry 4.0+ Bureau & Partners",
      },
      "Item 2 - Mentorship Sessions": {
        phase: "Mentorship Sessions",
        activities: [
          "Conduct training on AI/ML, IoT, and sovereign cloud use.",
          "Pair teams with mentors from academia, industry, and government.",
          "Provide orientation on datasets, cloud tools, and hardware kits.",
          "Ensure at least 80% completion by participants.",
        ],
        timeline: "Item 2",
        responsible: "Mentors & Technical Committee",
      },
      "Item 3 - Hacking Session": {
        phase: "Hacking Session (Online & Preselection)",
        activities: [
          "Host 72 hour hybrid hacking session (online + onsite at Deep Tech Centre of Excellence).",
          "Teams develop prototypes using cloud credits and hardware kits.",
          "Continuous mentorship and evaluation.",
          "Preselect top 10 projects.",
        ],
        timeline: "Item 3",
        responsible: "Technical Committee & Mentors",
      },
      "Item 4 - Pitching at Sovereign Cloud Launch": {
        phase: "Pitching at Sovereign Cloud Launch",
        activities: [
          "Final showcase of top 5 projects at the Sovereign Cloud launch event.",
          "Live demos and pitches before policymakers, investors, and industry leaders.",
          "Select 3 winning projects for incubation.",
          "Media coverage to promote visibility.",
        ],
        timeline: "Item 4",
        responsible: "Industry 4.0+ Bureau & Deep Tech Centre of Excellence",
      },
    },
    resources: {
      tools: [
        "TensorFlow",
        "PyTorch",
        "Google Cloud AI",
        "AWS SageMaker",
        "Jupyter Notebooks",
      ],
      datasets: [
        "Healthcare records (anonymized)",
        "Educational performance data",
        "Agricultural yield data",
        "Weather patterns",
      ],
      apis: [
        "Google Cloud AI APIs",
        "AWS AI Services",
        "Healthcare data APIs",
        "Agricultural data feeds",
      ],
      mentors: [
        "Dr. Sarah Nabwire (AI Researcher)",
        "James Mwangi (Healthcare Tech)",
        "Prof. David Mukasa (Agriculture)",
        "Lisa Chen (EdTech)",
      ],
    },
    milestones: [
      { title: "Application Submission", date: "2025-08-30" },
      { title: "Team Formation", date: "2025-09-10" },
      { title: "Pre-event Workshop", date: "2025-09-12" },
      { title: "Hackathon Kickoff", date: "2025-09-15" },
      { title: "Final Presentations", date: "2025-09-17" },
    ],
    lessons: {
      "2025-08-31": [
        {
          id: 1,
          title: "Introduction to AI Fundamentals",
          duration: "2 hours",
          instructor: "Dr. Sarah Nabwire",
          type: "video",
          status: "completed",
          description:
            "Learn the basics of artificial intelligence, machine learning concepts, and their applications in real-world scenarios.",
        },
        {
          id: 2,
          title: "Setting up Development Environment",
          duration: "1.5 hours",
          instructor: "James Mwangi",
          type: "tutorial",
          status: "in-progress",
          description:
            "Step-by-step guide to setting up your development environment with Python, TensorFlow, and Jupyter notebooks.",
        },
      ],
      "2025-09-01": [
        {
          id: 3,
          title: "Healthcare AI Applications",
          duration: "3 hours",
          instructor: "Prof. Lisa Chen",
          type: "video",
          status: "upcoming",
          description:
            "Explore how AI is transforming healthcare, from diagnostic tools to personalized medicine and patient care.",
        },
      ],
    },
  },
  {
    id: "7f3c2b1a-9d8e-4f7b-b6a1-23c45e6789fa",
    title: "National Science Week 2025",
    eventType: "conference",
    description:
      "National Science Week 2025 showcased 'Made in Uganda' innovations at Kololo Independence Grounds, highlighting Uganda's progress in translating scientific ideas into market-ready products.",
    fullDescription:
      "National Science Week 2025 showcased \"Made in Uganda\" innovations from June 15-20, 2025, at Kololo Independence Grounds, Kampala. Organized by the STI Secretariat, the event highlighted Uganda's progress in transforming scientific ideas into market-ready products like electric vehicles and locally developed therapeutics.\n\n�✨THEME ✨🌟\n\n🎯 MADE IN UGANDA: FROM INNOVATION TO MARKET\n🔥 Celebrating Uganda's homegrown innovations and their journey to market success! 🔥\n\n🔬 Innovation Showcase: Hundreds of innovators displayed products across health, agri-tech, renewable energy, and digital transformation sectors.\n\n🎤 National Science Summit: Featured research abstracts and cutting-edge developments",
    date: "June 15-20, 2025",
    startDate: "2025-06-15",
    endDate: "2025-06-20",
    location: "Kololo Independence Grounds, Kampala",
    funding: "Free and open to the public",
    deadline: "2025-06-15",
    requirements: [
      "Open to all innovators and entrepreneurs",
      "Family-friendly activities available",
      "Research presentations welcome",
    ],
    tags: [
      "Science",
      "Innovation",
      "Made in Uganda",
      "Research",
      "Entrepreneurship",
    ],
    image: "/Images/science_week.jpg",
    overview: {
      theme: "Made in Uganda: From Innovation to Market",
      objective:
        "Showcase Uganda's homegrown innovations and their journey from research to market-ready products across multiple sectors.",
      format:
        "6-day innovation showcase with exhibitions, summit presentations, networking, and family-friendly activities",
      audience:
        "Innovators, entrepreneurs, researchers, students, families, industry leaders, and the general public",
      expectedOutcome:
        "Increased visibility for Ugandan innovations, networking opportunities, and pathways to market for local products",
      videoUrl: "https://www.youtube.com/watch?v=0X2HujB8gDo&t=9s",
    },
    resources: {
      tools: [
        "Exhibition spaces",
        "Demo platforms",
        "Networking areas",
        "Presentation facilities",
      ],
      datasets: [
        "Innovation showcases",
        "Research abstracts",
        "Market data",
        "Investment opportunities",
      ],
      apis: [
        "Registration systems",
        "Event management platforms",
        "Networking tools",
      ],
      mentors: [
        "STI Secretariat officials",
        "Industry leaders",
        "Research experts",
        "Investment professionals",
      ],
    },
  },
  {
    id: "e2d1c4b3-5a6f-47e8-9c0d-1f23456789ab",
    title: "AI Innovation Academy",
    eventType: "workshop",
    description:
      "An intensive 16-week AI & Machine Learning bootcamp aimed at equipping participants with practical skills and knowledge to excel in the rapidly growing AI field.",
    fullDescription:
      "The AI4H-AI/ML Academy is a comprehensive Artificial Intelligence & Machine Learning bootcamp designed to transform participants into confident AI practitioners. This immersive 16-week program (4 months) combines theoretical knowledge with hands-on practical skill-building.\n\nProgram Structure:\n🤖 9 Weeks Technical Training: Master popular frameworks like Python, Pandas, TensorFlow, PyTorch, and MLOps\n💡2 Months Innovation Phase: Apply AI/ML skills to develop prototypes and MVPs through ideation and business incubation\n💰 Seed Funding Opportunity: Qualify for up to USD 4,000 to launch and test your solutions with real users\n\nCareer Preparation: Prepare for roles as AI Engineer, ML Engineer, Data Scientist, Analyst, and more\n\nComprehensive Curriculum: Covers AI/ML algorithms, data science, deep learning, natural language processing, generative AI, computer vision, AI ethics, and responsible AI practices.",
    date: "16-week program (4 months)",
    startDate: "2025-01-15",
    endDate: "2025-05-15",
    location: "Makerere University, Kampala & Online",
    funding: "Seed funding up to USD 4,000 available",
    deadline: "Apply via online portal",
    requirements: [
      "Ugandan or non-Ugandan residing in Uganda",
      "At least 18 years old",
      "English proficiency (written and spoken)",
      "Minimum diploma/degree in ICT, computer science, statistics, mathematics, engineering or related fields",
      "Basic programming knowledge (Python preferred)",
      "Access to laptop with at least 4GB RAM",
      "Reliable internet access",
      "Full commitment to attend all sessions",
    ],
    tags: [
      "AI",
      "Machine Learning",
      "Python",
      "TensorFlow",
      "Data Science",
      "Bootcamp",
      "Innovation",
    ],
    image: "/Images/ai21.jpg",
    overview: {
      theme: "AI/ML Practical Skills Development",
      objective:
        "Transform participants into confident AI practitioners with practical skills to solve real-world challenges in healthcare, agriculture, fintech, climate, and other sectors.",
      format:
        "16-week intensive program combining technical training, innovation development, and business incubation",
      audience:
        "Software developers, computer scientists, early-stage tech entrepreneurs, researchers, and students",
      expectedOutcome:
        "AI/ML-powered prototypes, MVPs, market-ready products, validated business models, and potential startup funding",
      videoUrl: "https://www.youtube.com/watch?v=OJFWfyY-_5M",
    },
    resources: {
      tools: [
        "Python",
        "TensorFlow",
        "PyTorch",
        "Pandas",
        "Keras",
        "MLOps tools",
        "Cloud computing resources",
        "AI toolkits",
      ],
      datasets: [
        "Real-world AI/ML datasets",
        "Sandbox environments",
        "APIs for experimentation",
      ],
      apis: ["AI/ML APIs", "Data analysis tools", "Prototyping platforms"],
      mentors: [
        "AI/ML technical mentors",
        "Data scientists",
        "ML engineers",
        "Business mentors",
        "Sector-specific experts",
      ],
    },
    workPlan: {
      "Phase 1 - Technical Training": {
        phase: "AI/ML Bootcamp (9 weeks)",
        activities: [
          "Introduction to AI/ML fundamentals",
          "Python programming for AI/ML",
          "Data handling & visualization",
          "Statistics & probability for ML",
          "Supervised and unsupervised learning",
          "Model evaluation & tuning",
          "Deep learning foundations",
          "Computer vision and NLP",
          "AI ethics & responsible AI",
        ],
        timeline: "Weeks 1-9",
        responsible: "AI/ML Technical Instructors",
      },
      "Phase 2 - Innovation Development": {
        phase: "Ideation & Prototyping (2 months)",
        activities: [
          "Design thinking and solution development",
          "Apply AI/ML skills to real-world problems",
          "Prototype and MVP development",
          "Business model validation",
          "Project presentations and pitch practice",
        ],
        timeline: "Weeks 10-16",
        responsible: "Innovation Mentors & Business Advisors",
      },
      "Phase 3 - Demo & Funding": {
        phase: "Demo Day & Seed Funding",
        activities: [
          "Final project presentations",
          "Demo day pitches to judging panel",
          "Seed funding evaluation (up to USD 4,000)",
          "Market readiness assessment",
        ],
        timeline: "Week 16+",
        responsible: "Review Panel & Funding Committee",
      },
    },
  },
  // {
  //     id: '12345678-90ab-cdef-1234-567890abcdef',
  //     title: "FinTech for Financial Inclusion",
  //     eventType: "hackathon",
  //     description: "Build innovative financial technology solutions for the unbanked.",
  //     fullDescription: "The FinTech for Financial Inclusion hackathon challenges participants to create innovative financial technology solutions that can bring banking services to the unbanked and underbanked populations in East Africa.\n\nParticipants will explore mobile money innovations, micro-lending platforms, blockchain applications for financial inclusion, and other technologies that can transform financial services accessibility.",
  //     date: "November 18-20, 2025",
  //     startDate: "2025-11-18",
  //     endDate: "2025-11-20",
  //     location: "Nairobi, Kenya",
  //     prizes: "$35,000 in prizes and partnership opportunities",
  //     deadline: "2025-10-31",
  //     requirements: ["Financial or technical background", "Team of 2-5 members", "Understanding of local financial challenges"],
  //     tags: ["FinTech", "Financial Inclusion", "Mobile Money", "Blockchain"],
  //     image: "Images/background.jpg",
  //     judges: [
  //         { name: "Dr. Patricia Nakibuuka", title: "FinTech Innovation Lead", organization: "Bank of Uganda" },
  //         { name: "Samuel Kigozi", title: "Mobile Money Director", organization: "MTN Mobile Money" },
  //         { name: "Rachel Mwangi", title: "Blockchain Specialist", organization: "Binance Africa" },
  //         { name: "Dr. Joseph Lutwama", title: "Financial Inclusion Expert", organization: "UNCDF" },
  //         { name: "Grace Asiimwe", title: "Microfinance Innovation", organization: "FINCA Uganda" },
  //         { name: "Mark Kaigwa", title: "Digital Banking Lead", organization: "Equity Bank" },
  //         { name: "Dr. Susan Nakacwa", title: "Payment Systems Expert", organization: "Visa Africa" }
  //     ],
  //     resources: {
  //         tools: ["Mobile development frameworks", "Blockchain platforms", "Payment APIs"],
  //         datasets: ["Financial inclusion data", "Mobile money statistics", "Banking accessibility data"],
  //         apis: ["Payment processing APIs", "Banking APIs", "Mobile money APIs"],
  //         mentors: ["FinTech Entrepreneurs", "Banking Experts", "Mobile Money Specialists"]
  //     }
  // },
  // {
  //     id: '9a8b7c6d-5e4f-41a2-b3c9-7d8e9f012345',
  //     title: "AgriTech Innovation Challenge",
  //     eventType: "grant",
  //     description: "Create tech solutions for agricultural productivity and market access.",
  //     fullDescription: "The AgriTech Innovation Challenge invites innovators to develop technology solutions that increase agricultural productivity, improve market access for farmers, and enhance food security in East Africa.\n\nParticipants will work on solutions like smart farming tools, supply chain innovations, market platforms, and data analytics systems to transform agricultural practices.",
  //     date: "December 8-10, 2025",
  //     startDate: "2025-12-08",
  //     endDate: "2025-12-10",
  //     location: "Jinja, Uganda",
  //     funding: "$30,000 in funding and pilot opportunities",
  //     deadline: "2025-11-15",
  //     requirements: ["Agricultural knowledge helpful", "Team of 2-5 members", "Passion for food security"],
  //     tags: ["AgriTech", "Food Security", "Supply Chain", "Rural Development"],
  //     image: "Images/background.jpg",
  //     resources: {
  //         tools: ["IoT sensors", "Drone technology", "Data analytics platforms", "Mobile apps"],
  //         datasets: ["Agricultural yield data", "Weather patterns", "Market price data", "Soil analysis"],
  //         apis: ["Weather APIs", "Agricultural data APIs", "Market data feeds"],
  //         mentors: ["Agricultural Scientists", "Tech Entrepreneurs", "Supply Chain Experts"]
  //     }
  // },
  // {
  //     id: '0f1e2d3c-4b5a-6789-8c7d-6e5f4a3b2c1d',
  //     title: "Healthcare Innovation Summit",
  //     eventType: "workshop",
  //     description: "Design tech-enabled healthcare solutions for underserved communities.",
  //     fullDescription: "The Healthcare Innovation Summit brings together medical professionals, engineers, designers, and entrepreneurs to develop technology-enabled healthcare solutions for underserved communities.\n\nFocus areas include telemedicine, diagnostic tools, health monitoring systems, and platforms that improve healthcare access and quality.",
  //     date: "February 12-14, 2026",
  //     startDate: "2026-02-12",
  //     endDate: "2026-02-14",
  //     location: "Kampala, Uganda",
  //     deadline: "2026-01-20",
  //     requirements: ["Health background helpful", "Team of 2-4 members", "Understanding of local health challenges"],
  //     tags: ["Healthcare", "Telemedicine", "Med-Tech", "Accessibility"],
  //     image: "Images/background.jpg"
  // },
  // {
  //     id: 'abcd1234-5678-90ef-ab12-cd34567890ef',
  //     title: "Blockchain for Transparency",
  //     eventType: "meetup",
  //     description: "Leverage blockchain technology for transparency in government and business.",
  //     fullDescription: "The Blockchain for Transparency hackathon focuses on creating blockchain solutions that enhance transparency and accountability in government services, supply chains, and business operations across East Africa.",
  //     date: "August 20-25, 2025",
  //     startDate: "2025-08-20",
  //     endDate: "2025-08-25",
  //     location: "Dar es Salaam, Tanzania",
  //     deadline: "2025-08-10",
  //     requirements: ["Blockchain knowledge preferred", "Team of 2-4 members", "Interest in governance"],
  //     tags: ["Blockchain", "Transparency", "Governance", "Supply Chain"],
  //     image: "Images/background.jpg"
  // }
];
